<template>
    <div class="dynamic-phone-container">
        <v-row dense>
            <v-col cols="12" sm="6">
                <PhoneField
                    :id="id"
                    class="dynamic-phone-field"
                    v-bind="$attrs"
                    :value="phone"
                    :label="label"
                    :disabled="hasProvePrefill"
                    @input="updatePhone"
                >
                    <template #label><slot name="label">{{$attrs.label}}</slot></template>
                    <template #message="messageProps">
                        <slot name="message" :message="messageProps.message" />
                    </template>
                </PhoneField>
            </v-col>
            <v-col cols="12" sm="6">
                <RadioField
                    :id="`dynamic-phone-radio-${id}`"
                    class="dynamic-phone-radio"
                    row
                    required
                    name-field="label"
                    sort-by="-label"
                    :value="value"
                    :options="phoneTypes"
                    :disabled="hasProvePrefill"
                    :radio-attrs="radioAttrs"
                    @input="updatePhoneType"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import FieldProxyMixin from "@/components/form/FieldProxyMixin.vue"
    import { proveState } from "@/state"

    export default {
        mixins: [FieldProxyMixin],
        props: {
            label: {
                type: String,
            },

            homePhone: {
                type: String,
            },

            mobilePhone: {
                type: String,
            },

            value: {
                type: String,
            },

            phoneTypes: {
                type: Array,
                required: true,
            },
            radioAttrs: {
                type: Object,
                default: () => {
                    return {}
                },
            },

            applicantType: {
                type: String,
                validator: value => ["primary", "joint"].includes(value),
                default: "primary",
            },
        },

        computed: {
            computedPhoneType() {
                if (proveState.prefilledFields.includes(`${this.applicantType}.mobilePhone`)) {
                    return "mobile"
                } else if (proveState.prefilledFields.includes(`${this.applicantType}.homePhone`)) {
                    return "homePhone"
                }
                return this.value || "mobile"
            },

            phone() {
                if (this.computedPhoneType === "home") {
                    return this.homePhone
                } else {
                    return this.mobilePhone
                }
            },

            hasProvePrefill() {
                if (this.computedPhoneType === "mobile") {
                    return proveState.prefilledFields.includes(`${this.applicantType}.mobilePhone`)
                } else {
                    return proveState.prefilledFields.includes(`${this.applicantType}.homePhone`)
                }
            },
        },

        methods: {
            updatePhoneType(type) {
                this.$emit("input", { phone: this.phone, type })
            },

            updatePhone(phone) {
                this.$emit("input", { phone, type: this.computedPhoneType })
            },
        },
    }
</script>

<style lang="scss" scoped>
    @media screen and (max-width: 992px) {
        .dynamic-phone-radio {
            margin-top: -10px !important;
            margin-bottom: 0 !important;

            &::v-deep .v-input__slot {
                margin-bottom: 0;
            }
        }
    }
</style>
